import React from "react";
import { fetchProducts  } from "../fetchData";

const useFetchProducts = ({ mode, limit, offset }:{ mode?: string, limit?: number, offset?: number }) => {
  const [products, setProducts] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listProducts();
  }, []);

  const listProducts = () => {
    setLoading(true);
    setLoaded(false);
 fetchProducts( { offset: offset, limit: limit, mode: mode })
      .then(
        (result) => {
          setLoading(false);
          console.log(result);
            setProducts(result?.status ? result.data : []);
        },
        (error) => {
          setProducts([]);
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {products,loading,loaded};
};

export default useFetchProducts;
